export const    KEYCLOAK = 'KEYCLOAK';
export const    KEYCLOAK_SUCCESS = 'KEYCLOAK_SUCCESS';
export const    KEYCLOAK_ERROR = 'KEYCLOAK_ERROR';